import bodymovin              from 'lottie-web';
import {x, x0} from '../_helpers';

export default class SvgAnimations {

    constructor() {
        this.init();
    }

    init() {
        const introAnimation = bodymovin.loadAnimation({
            container: x0('#video-bg'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: './assets/data/nocode.json'
        })

        const footerAnimation = bodymovin.loadAnimation({
            container: x0('#video-bg-outline'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: './assets/data/nocode_outline.json'
        });
    }
}